import React, { useState } from 'react';
import { Box } from '@mui/material';
import FormGenerator from '../FormGenerator';
import { apiMyLead } from '../../../app/constants/urls';
import { sendYandexMetrikaEvent } from '../../../helpers/yandexMetrika';
import { sendLeadData } from '../../../helpers/amoLead';

const formInfo = {
  program: null,
  pipelineType: 'subscribeNew',
  eventName:
    'Присылаем статьи, материалы по программированию и IT-новости раз в неделю',
};

const formFields = [
  {
    id: 'email',
    name: 'email',
    label: 'Email',
    type: 'email',
    rules: {
      required: 'Введите адрес почты',
    },
  },
];

export default function SubscriptionForm({ setIsSent, setIsError }) {
  const [isLoading, setIsLoading] = useState(false);
  const sendForm = async (data) => {
    const formData = {
      ...data,
      ...formInfo,
    };

    try {
      setIsError(false);
      setIsLoading(true);
      await sendLeadData(formData);
      // await fetch( apiMyLead, {
      //   method: 'POST',
      //   cache: 'no-cache',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify(formData),
      // });
      setIsSent(true);
      sendYandexMetrikaEvent('formSend');
    } catch (e) {
      setIsError(true);
      console.error(e.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box>
      <FormGenerator
        isLoading={isLoading}
        submitHandler={sendForm}
        fields={formFields}
        buttonLabel="Подписаться"
      />
    </Box>
  );
}
